import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  overflow: auto;
  height: 100%;
  width: 100%;
  background-size: cover;
`

export const GreenContainer = styled.div`
  overflow: auto;
  height: 100%;
  width: 100%;
  background-color: ${colors.primary};
  opacity: 0.96;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  box-sizing: border-box;
  padding: 4% 0 2% 0;

  @media (max-width: 450px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  width: 310px;

  @media (max-width: 410px) {
    width: 200px;
  }
`
